import clsx from 'clsx'
import { ReactNode } from 'react'

function FloatBox({ className, children }: FloatBoxProps) {
  return (
    <div
      className={clsx(
        'bg-white border rounded-xl p-6 sm:p-8 md:p-14 border-sbtgray-100',
        className
      )}
      style={{
        boxShadow: 'rgba(80,80,80,0.05) 0px 9px 40px -3px',
      }}
    >
      {children}
    </div>
  )
}

interface FloatBoxProps {
  className?: string
  children: ReactNode
}

export default FloatBox
